import { render } from "./VideoEmbedPreview.vue?vue&type=template&id=7ba8f7e6&ts=true"
import script from "./VideoEmbedPreview.vue?vue&type=script&lang=ts"
export * from "./VideoEmbedPreview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__